<script>
export default {
  name: 'PhoneDialpad',
  emits: ['dtmfTone'],
  data() {
    return {
      dialpadButtons: [
        [
          { digit: '1', letters: '' },
          { digit: '2', letters: 'ABC' },
          { digit: '3', letters: 'DEF' },
        ],
        [
          { digit: '4', letters: 'GHI' },
          { digit: '5', letters: 'JKL' },
          { digit: '6', letters: 'MNO' },
        ],
        [
          { digit: '7', letters: 'PQRS' },
          { digit: '8', letters: 'TUV' },
          { digit: '9', letters: 'WXYZ' },
        ],
        [
          { digit: '*', letters: '' },
          { digit: '0', letters: '+' },
          { digit: '#', letters: '' },
        ],
      ],
    };
  },
  methods: {
    sendDTMF(tone) {
      this.$emit('dtmfTone', tone);
    },
  },
};
</script>

<template>
  <div class="dialpad-inline">
    <div class="dialpad-container">
      <div class="dialpad-grid">
        <div
          v-for="(row, rowIndex) in dialpadButtons"
          :key="rowIndex"
          class="dialpad-row"
        >
          <button
            v-for="button in row"
            :key="button.digit"
            class="dialpad-button"
            @click="sendDTMF(button.digit)"
          >
            <div class="dialpad-digit">{{ button.digit }}</div>
            <div v-if="button.letters" class="dialpad-letters">
              {{ button.letters }}
            </div>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
@import 'dashboard/assets/scss/_mixins.scss';

.dialpad-inline {
  margin-bottom: 16px;
}

.dialpad-container {
  border-radius: 8px;
  padding: 16px;
}

.dark .dialpad-container {
  color: #dcddde;
}

.dialpad-grid {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.dialpad-row {
  display: flex;
  gap: 16px;
  justify-content: center;
}

.dialpad-button {
  width: 50px;
  height: 50px;
  border: 1px solid #d1d5db;
  border-radius: 50%;
  background-color: #ffffff;
  cursor: pointer;
  transition: all 0.15s ease;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);

  &:hover {
    background-color: #f3f4f6;
    border-color: #9ca3af;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
  }

  &:active {
    background-color: #e5e7eb;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
    transform: translateY(1px);
  }
}

.dark .dialpad-button {
  background-color: #374151;
  border-color: #6b7280;
  color: #f3f4f6;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);

  &:hover {
    background-color: #4b5563;
    border-color: #9ca3af;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.4);
  }

  &:active {
    background-color: #1f2937;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
  }
}

.dialpad-digit {
  font-size: 18px;
  font-weight: 500;
  line-height: 1;
  color: #1f2937;
}

.dark .dialpad-digit {
  color: #e2e8f0;
}

.dialpad-letters {
  font-size: 9px;
  font-weight: 400;
  line-height: 1;
  margin-top: 2px;
  color: #6b7280;
}

.dark .dialpad-letters {
  color: #a0aec0;
}
</style>
